import styled from 'styled-components';

export const ModalStyle = styled.div`
  .modalDiv {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .filterButton {
    width: 80%;
    height: 37px;
  }
  .heading {
    display: block;
    height: 15px;
    margin-top: 0;
    margin-bottom: 4px;
    margin-left: 2px;
  }
  .addIcon {
    margin-top: 15px;
    margin-bottom: 15px;
    margin-right: 5px;
  }
  .footer {
    align-items: right;
    width: 100%;
  }
  .footerBtn {
    width: 100%;
  }
`;
export const SingleSelectDW = styled.div`
  .singleSelectDW {
    width: 80%;
    height: 80%;
  }
`;
export const FormStyle = styled.div`
  .heading {
    margin-top: 5px;
    margin-bottom: 1px;
    margin-left: 2px;
    font-weight: 1000;
    font-family: lg-smart, sans-serif;
    color: rgb(15, 33, 95);
    width: 100%;
    text-align: left;
  }
`;
